module.exports = __webpack_public_path__ + "static/img/tuuci_cantilever.30ee875.png";